import { useCallback } from 'react';
const dataPropName = 'data-focus-on-ignore';
export const useFocusOnIgnore = () => {
  const isTargetIgnored = useCallback(target => Boolean(target == null ? void 0 : target.closest(`[${dataPropName}]`)), []);
  const documentMouseDown = useCallback(event => {
    if (isTargetIgnored(event.target)) {
      event.preventDefault();
    }
  }, [isTargetIgnored]);
  return {
    focusOnIgnoreProps: {
      [dataPropName]: true
    },
    dataPropName,
    isTargetIgnored,
    documentMouseDown
  };
};